export const CURR_PRODUCT_ADD = 'CURR_PRODUCT_ADD';
export const CURR_PRODUCT_DEL = 'CURR_PRODUCT_DEL';

